<div class="dialog-wrapper content-creation">
  <h2 *ngIf="isNewPost" mat-dialog-title>
    {{ "brand.campaign.contentCalendarImagePost.createTitle" | translate }}
  </h2>
  <h2 *ngIf="!isNewPost" mat-dialog-title>
    {{ "brand.campaign.contentCalendarImagePost.updateTitle" | translate }}
  </h2>
  <mat-dialog-content>
    <form>
      <section class="upload-image">
        <h3 *ngIf="post.mediaType === CampaignPostContentType.Image">
          {{ "brand.campaign.contentCalendarImagePost.image" | translate }}
          <app-tooltip
            text="{{
              'brand.campaign.contentCalendarImagePost.imageToolTip' | translate
            }}"
          ></app-tooltip>
        </h3>
        <h3 *ngIf="post.mediaType === CampaignPostContentType.Image360">
          {{ "brand.campaign.contentCalendarImagePost.image360" | translate }}
          <app-tooltip
            text="{{
              'brand.campaign.contentCalendarImagePost.imageToolTip' | translate
            }}"
          ></app-tooltip>
        </h3>
        <img
          *ngIf="
            (post.mediaType === CampaignPostContentType.Image ||
              post.mediaType === CampaignPostContentType.Gif) &&
            post.image
          "
          class="item-img"
          [src]="post.image"
        />
        <div
          *ngIf="
            post.mediaType === CampaignPostContentType.Image360 && post.image
          "
          class="item-img-wrap"
        >
          <app-panoramic-viewer [imageUrl]="post.image" />
        </div>
        <app-file-uploader
          [uploaderTitle]="
            'brand.campaign.contentCalendarCarouselPost.dragDropImage'
              | translate
          "
          uploaderSubtitle="{{
            'brand.campaign.contentCalendarCarouselPost.dragDropImage'
              | translate
          }} {{ uploaderMimeTypes }}"
          (fileAddedToQueue)="fileAddedToQueue($event)"
          (apiResponse)="handleFileUploadResponse($event)"
          [uploadUrl]="uploaderUrl"
          [uploadData]="uploadData"
          [acceptFormat]="acceptFormat"
          [maxFileSize]="maxFileSizeInBytes"
          (uploadError)="fileUploaderErrorHandler($event)"
          [customFileValidators]="customFileValidators"
          [responseMapper]="fileUploaderResponseMapper"
        />
      </section>
      <app-brand-campaign-content-form-post-suggested-text
        *ngIf="displayedPostTags"
        #suggestedText
        [text]="post.text"
        [postTags]="displayedPostTags"
        [type]="campaign.type"
        (textChanged)="textChanged($event)"
        [platformsSelected]="{
          instagram: post?.postToInstagram,
          facebook: post?.postToFacebook
        }"
      >
      </app-brand-campaign-content-form-post-suggested-text>
      <section class="channels">
        <h3 class="channels-title">
          {{ "brand.campaign.contentCalendarPost.chooseChannels" | translate }}
          <app-tooltip
            text="{{
              'brand.campaign.contentCalendarPost.chooseChannelsToolTip'
                | translate
            }}"
          ></app-tooltip>
        </h3>
        <mat-checkbox
          class="channels-checkbox"
          name="facebookPlatform"
          [(ngModel)]="post.postToFacebook"
          (ngModelChange)="checkSaveDisabled()"
        >
          Facebook
        </mat-checkbox>

        <mat-checkbox
          [disabled]="!canPostToInstagram() || isDisableInstagramChannel"
          class="channels-checkbox channels-checkbox--right"
          name="instagramPlatform"
          [(ngModel)]="post.postToInstagram"
          (ngModelChange)="postToInstagramChange($event)"
        >
          Instagram
        </mat-checkbox>
      </section>
      <span *ngIf="isDisableInstagramChannel">{{
        "brand.campaign.contentCalendarPost.aspectRatioNotAllowed" | translate
      }}</span>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button class="btn btn--transparent" tabindex="-1" [mat-dialog-close]="">
      {{ "shared.cancel" | translate }}
    </button>
    <button
      class="btn btn--primary"
      tabindex="-1"
      (click)="onSaveContent()"
      [disabled]="saveDisabled"
    >
      <span *ngIf="saving">{{ "shared.saving" | translate }}</span>
      <span *ngIf="!saving">{{
        "brand.campaign.contentCalendarPost.savePost" | translate
      }}</span>
    </button>
  </mat-dialog-actions>
</div>
